import { TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import moment from 'moment';
import { displayDateFormatShort } from '../../../constants';
import { useState } from 'react';
import ViewUtilization from './ViewUtilization';

const RentalUtilizationList = ({ item, leaseSlug, toggleBulkOps, bulk, handleItemClicked }) => {

    const [viewUtilization, setViewUtilization] = useState({ mode: '', modal: false, data: {}, type: '' })
    return (
        <>
            <Tooltip title="View Utilization" arrow>
                <TableRow style={{ cursor: "pointer" }} onClick={() => { setViewUtilization({ modal: true, data: item }); handleItemClicked?.('View Utilization Row - RentalUtilizationList') }} >
                    <TableCell>{item?.start_date || item?.end_date ? `${moment(item.start_date).format(displayDateFormatShort) + "-" + moment(item.end_date).format(displayDateFormatShort)}` : '--'}</TableCell>
                    <TableCell> <Typography color="primary" variant="body2" sx={{ textDecoration: "underline" }}> {item?.asset_name?.name || '--'} </Typography> </TableCell>
                    <TableCell>{item?.utilization_type || '--'}</TableCell>
                </TableRow>
            </Tooltip>
            {viewUtilization.modal ?
                <ViewUtilization
                    item={item}
                    leaseSlug={leaseSlug}
                    onToggleModal={() => setViewUtilization({ modal: false, mode: '', data: null })}
                /> : null}
        </>
    )
}
export default RentalUtilizationList
